import { Upload } from '@mui/icons-material';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { ChangeEvent, useRef } from 'react';

import useTranslate from 'hooks/useTranslate';

interface UploadDocumentProps {
    onUpload: (file: File) => void;
    disabled?: boolean;
    loading?: boolean;
    accept?: string;
    tooltip?: string;
}

export const DOCUMENT_UPLOAD_ACCEPT =
    'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx';

const UploadDocument = ({
    onUpload,
    disabled,
    loading,
    accept = DOCUMENT_UPLOAD_ACCEPT,
    tooltip,
}: UploadDocumentProps) => {
    const { translate } = useTranslate();
    const inputRef = useRef<HTMLInputElement | null>(null);
    const label = tooltip ?? translate('documentsUpload');

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) onUpload(file);
        event.target.value = '';
    };

    return (
        <>
            <input ref={inputRef} type="file" hidden accept={accept} onChange={handleChange} />
            <Tooltip title={label}>
                <span>
                    <IconButton
                        size="small"
                        disabled={disabled || loading}
                        onClick={() => inputRef.current?.click()}
                        aria-label={label}
                    >
                        {loading ? <CircularProgress size={18} /> : <Upload fontSize="small" />}
                    </IconButton>
                </span>
            </Tooltip>
        </>
    );
};

export default UploadDocument;
